import ApiService from './ApiService';

export async function updateApplicationWithDebugToolbar(
  applicationId: string,
  data: { subsectionId: string },
): Promise<any> {
  const response = await ApiService.updateApplicationWithDebugToolbar(applicationId, data);
  return response.data;
}
